import { styled } from '@mui/material/styles';
import { MenuLink } from './MenuLink';

export const SubMenuLink = styled(MenuLink)`
  background-color: ${(props) => props.scheme?.subMenuLinkBackground};
  padding-left: 17px;
  border-left: solid 3px ${(props) => props.scheme?.activeLinkBorder};
  &.active {
    background-color: ${(props) => props.scheme?.activeSubMenuLinkBackground};
    color: ${(props) => props.scheme?.activeLinkColor};
  }
  &:hover {
    background-color: ${(props) => props.scheme?.activeSubMenuLinkBackground};
    color: ${(props) => props.scheme?.activeLinkColor};
  }
  &:not(.active):hover {
    background-color: ${(props) => props.scheme?.activeSubMenuLinkBackground};
    color: ${(props) => props.scheme?.linkHoverColor};
  }
`;
